var _g, _g2, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageBotIntroduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 191,
    viewBox: "0 0 240 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4373_100324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.975 37.484C219.975 36.8196 219.823 36.1668 219.535 35.5718C219.247 34.9767 218.824 34.4625 218.31 34.0639C217.791 33.6653 217.193 33.3938 216.555 33.2782C215.918 33.1569 215.263 33.1916 214.642 33.3764C214.247 31.8744 213.356 30.5629 212.114 29.6675C210.873 28.772 209.366 28.3503 207.854 28.4716C206.342 28.5929 204.92 29.2573 203.831 30.3376C202.747 31.4237 202.064 32.8623 201.906 34.4048C201.32 34.1852 200.699 34.1044 200.078 34.1621C199.457 34.2199 198.859 34.4221 198.329 34.7514C197.798 35.0807 197.341 35.5255 196.997 36.057C196.653 36.5885 196.433 37.1951 196.348 37.8249V37.8768C196.348 37.9115 196.331 37.9924 196.326 38.0502C196.326 38.1079 196.309 38.2755 196.309 38.4199C196.309 38.9803 196.416 39.5349 196.625 40.0548C196.833 40.5748 197.144 41.0428 197.533 41.4414C197.922 41.84 198.38 42.152 198.887 42.3657C199.395 42.5795 199.937 42.6892 200.484 42.6835H215.489C216.144 42.6835 216.792 42.5333 217.379 42.2386C217.966 41.944 218.485 41.5165 218.886 40.985C219.58 40.0548 220.189 38.8128 219.975 37.4667V37.484Z",
    fill: "url(#paint0_linear_4373_100324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2883 36.3003C54.2883 35.324 54.0682 34.3592 53.645 33.481C53.2218 32.6087 52.601 31.8461 51.8336 31.2568C51.0718 30.6675 50.1859 30.2747 49.2435 30.1014C48.3068 29.9281 47.3362 29.9801 46.422 30.2516C45.8408 28.0389 44.526 26.1094 42.6977 24.7922C40.8694 23.475 38.6517 22.851 36.4227 23.0301C34.1938 23.215 32.1002 24.1855 30.5033 25.7858C28.9063 27.3861 27.9019 29.5063 27.6762 31.7825C26.8185 31.459 25.893 31.3377 24.9845 31.4244C24.0704 31.511 23.1901 31.8114 22.4057 32.2909C21.6213 32.7762 20.9498 33.4348 20.4476 34.2147C19.9454 35.0004 19.6181 35.8901 19.4939 36.8203V36.9011C19.4939 36.9531 19.4714 37.0744 19.4657 37.1611C19.4488 37.2998 19.4431 37.4846 19.4375 37.7042C19.4375 38.5303 19.5955 39.3507 19.9059 40.1132C20.2162 40.8758 20.6677 41.5691 21.2376 42.1526C21.8075 42.7361 22.4903 43.1983 23.2352 43.5102C23.9801 43.8222 24.7814 43.984 25.5883 43.9782H47.686C48.651 43.9782 49.6046 43.7529 50.468 43.3196C51.337 42.8863 52.0932 42.2566 52.6857 41.4767C53.7127 40.1017 54.6156 38.2703 54.2883 36.283V36.3003Z",
    fill: "url(#paint1_linear_4373_100324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 148.024C3 148.024 14.5849 68.1661 32.9019 71.3782C51.2132 74.5903 51.0383 89.4377 61.6019 87.2943C72.1711 85.151 63.2948 57.3165 92.4292 56.4037C116.468 55.6527 113.032 81.5865 125.023 81.055C137.014 80.5235 131.157 45.9066 168.191 46.207C192.89 46.4092 196.378 87.5659 206.242 88.6289C216.105 89.6919 216.811 75.7804 225.27 78.4553C233.728 81.1301 239.061 140.109 236.239 150.814C236.239 150.814 173.101 145.996 119.149 150.814C65.1964 155.633 3.00564 148.018 3.00564 148.018L3 148.024Z",
    fill: "url(#paint2_linear_4373_100324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1935 117.713C35.1935 117.066 34.6856 116.546 34.0536 116.546C33.4216 116.546 32.9137 117.066 32.9137 117.713V122.41C32.9137 123.057 33.4216 123.577 34.0536 123.577C34.6856 123.577 35.1935 123.057 35.1935 122.41V117.713ZM34.0592 117.898C38.6921 117.898 42.4446 114.056 42.4446 109.313C42.4446 104.57 38.6921 100.729 34.0592 100.729C29.4264 100.729 25.6738 104.57 25.6738 109.313C25.6738 114.056 29.4264 117.898 34.0592 117.898Z",
    fill: "url(#paint3_linear_4373_100324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.386 28.4863H98.997C93.1317 28.4863 88.377 33.3542 88.377 39.359V188.127C88.377 194.132 93.1317 199 98.997 199H165.386C171.251 199 176.006 194.132 176.006 188.127V39.359C176.006 33.3542 171.251 28.4863 165.386 28.4863Z",
    fill: "url(#paint4_linear_4373_100324)",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.888 35.4472H164.965L164.971 35.4414C167.318 35.4414 169.22 37.3883 169.22 39.7916V187.693C169.22 190.097 167.318 192.044 164.971 192.044H99.4337C97.0862 192.044 95.1846 190.097 95.1846 187.693V39.7974C95.1846 37.3941 97.0862 35.4472 99.4337 35.4472H114.421C114.536 35.4472 114.649 35.4565 114.76 35.4746H148.55C148.661 35.4565 148.774 35.4472 148.888 35.4472Z",
    fill: "#BBE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.632 90.3613H108.561C106.623 90.3613 105.051 91.9702 105.051 93.9547V107.45C105.051 109.435 106.623 111.044 108.561 111.044H181.632C183.57 111.044 185.141 109.435 185.141 107.45V93.9547C185.141 91.9702 183.57 90.3613 181.632 90.3613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.477 101.807L117.497 103.667L116.814 102.442L119.828 100.721L116.814 98.9645L117.497 97.7744L120.477 99.6347L120.409 96.0586H121.78L121.713 99.6347L124.692 97.7744L125.375 98.9645L122.361 100.721L125.375 102.442L124.692 103.667L121.713 101.807L121.78 105.348H120.409L120.477 101.807ZM136.474 101.807L133.495 103.667L132.812 102.442L135.826 100.721L132.812 98.9645L133.495 97.7744L136.474 99.6347L136.407 96.0586H137.778L137.71 99.6347L140.69 97.7744L141.372 98.9645L138.359 100.721L141.372 102.442L140.69 103.667L137.71 101.807L137.778 105.348H136.407L136.474 101.807ZM152.472 101.807L149.493 103.667L148.81 102.442L151.823 100.721L148.81 98.9645L149.493 97.7744L152.472 99.6347L152.404 96.0586H153.776L153.708 99.6347L156.687 97.7744L157.37 98.9645L154.357 100.721L157.37 102.442L156.687 103.667L153.708 101.807L153.776 105.348H152.404L152.472 101.807ZM168.47 101.807L165.49 103.667L164.808 102.442L167.821 100.721L164.808 98.9645L165.49 97.7744L168.47 99.6347L168.402 96.0586H169.773L169.706 99.6347L172.685 97.7744L173.368 98.9645L170.355 100.721L173.368 102.442L172.685 103.667L169.706 101.807L169.773 105.348H168.402L168.47 101.807Z",
    fill: "url(#paint5_linear_4373_100324)",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.073 72.5349C136.966 72.5349 140.932 68.474 140.932 63.4647C140.932 58.4554 136.966 54.3945 132.073 54.3945C127.18 54.3945 123.213 58.4554 123.213 63.4647C123.213 68.474 127.18 72.5349 132.073 72.5349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.13 60.4205C134.085 59.2998 133.176 58.4043 132.07 58.4043C130.964 58.4043 130.011 59.3518 130.011 60.513V62.6216H129.187C128.73 62.6216 128.363 62.9972 128.363 63.4651V67.6882C128.363 68.1562 128.73 68.5317 129.187 68.5317H134.959C135.416 68.5317 135.783 68.1562 135.783 67.6882V63.4651C135.783 62.9972 135.416 62.6216 134.959 62.6216H134.136V60.4205H134.13ZM133.306 62.6216V60.513C133.306 59.8139 132.753 59.2478 132.07 59.2478C131.387 59.2478 130.874 59.7735 130.834 60.4379V60.513V62.6216H133.306ZM130.422 63.4651H129.187V67.6882H134.959V63.4651H130.422ZM131.658 65.152C131.658 64.921 131.844 64.7303 132.07 64.7303C132.296 64.7303 132.482 64.921 132.482 65.152V65.9955C132.482 66.2266 132.296 66.4172 132.07 66.4172C131.844 66.4172 131.658 66.2266 131.658 65.9955V65.152Z",
    fill: "url(#paint6_linear_4373_100324)",
    fillOpacity: 0.85
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4373_100324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.0412 158C93.9517 158 92.8976 157.77 91.9023 157.321C83.2688 153.42 62.8569 143.08 59.7533 131.371C57.9453 124.56 57.6332 115.784 57.3329 107.291C57.0443 99.0518 56.7675 91.273 55.1833 86.0499C54.6592 84.3147 55.2834 82.4379 56.7439 81.3873C58.8405 79.8765 61.9676 78.0705 64.9299 78.0705C65.9546 78.0705 66.8969 78.283 67.739 78.7079C68.9816 79.3335 70.3126 79.6345 71.7967 79.6345C76.0486 79.6345 80.7894 77.0849 84.9707 74.8362C88.7751 72.7883 92.0613 71.0236 94.9588 71H95.0177C97.9387 71.0236 101.225 72.7883 105.029 74.8362C109.211 77.0849 113.951 79.6345 118.203 79.6345C119.687 79.6345 121.018 79.3335 122.261 78.7079C123.103 78.2889 124.045 78.0705 125.07 78.0705C128.032 78.0705 131.16 79.8706 133.256 81.3873C134.717 82.4379 135.341 84.3147 134.817 86.0499C133.233 91.273 132.956 99.0518 132.667 107.291C132.367 115.778 132.055 124.554 130.247 131.371C127.078 143.31 106.731 153.509 98.133 157.339C97.1495 157.776 96.1072 158 95.0353 158H95.0412Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.084 80.3549C113.473 85.1768 101.618 72.8949 95.022 72.8418H94.9749C88.3849 72.8949 76.53 85.1768 66.913 80.3549C64.0273 78.909 59.9343 81.3464 57.8083 82.8809C56.9779 83.477 56.6305 84.5394 56.9308 85.5191C60.2641 96.4966 58.0321 117.761 61.5185 130.899C64.4807 142.071 85.511 152.423 92.6545 155.651C94.1621 156.33 95.8818 156.336 97.3953 155.663C104.568 152.47 125.457 142.284 128.478 130.899C131.965 117.761 129.739 96.4966 133.066 85.5191C133.36 84.5394 133.019 83.477 132.189 82.8809C130.063 81.3464 125.964 78.909 123.084 80.349V80.3549Z",
    fill: "url(#paint7_linear_4373_100324)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0436 152.865C94.6844 152.865 94.3369 152.789 94.013 152.641C90.503 151.053 83.6657 147.754 77.3584 143.511C68.2243 137.361 65.4328 132.799 64.7085 130.055C63.0477 123.798 62.7474 115.317 62.4588 107.114C62.1644 98.8334 61.8876 91.0016 60.2739 85.1882C62.1172 83.9429 63.8251 83.2111 64.9323 83.2111C65.1502 83.2111 65.3268 83.2406 65.4505 83.3055C67.3939 84.2793 69.5317 84.7751 71.8049 84.7751C77.3466 84.7751 82.6881 81.9008 87.4053 79.3689C90.3382 77.7931 93.3652 76.1642 95.0024 76.1465H95.0142C96.6513 76.1642 99.6843 77.799 102.617 79.3748C107.328 81.9067 112.676 84.781 118.212 84.781C120.479 84.781 122.617 84.2852 124.566 83.3114C124.69 83.2524 124.86 83.217 125.078 83.217C126.186 83.217 127.893 83.9488 129.737 85.1941C128.123 91.0016 127.846 98.8334 127.552 107.114C127.263 115.317 126.963 123.798 125.302 130.055C124.23 134.086 119.861 138.778 112.664 143.617C106.374 147.843 99.5606 151.095 96.0624 152.653C95.7385 152.795 95.3969 152.871 95.0495 152.871L95.0436 152.865Z",
    fill: "url(#paint8_linear_4373_100324)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M126.467 111.186C126.467 111.186 112.179 134.876 94.5472 134.876C76.915 134.876 63.423 111.304 63.423 111.304C63.423 111.304 58.0579 142.956 95.2775 151.915L95.3953 151.956L95.513 151.915C132.662 142.236 126.467 111.18 126.467 111.18V111.186Z",
    fill: "url(#paint9_linear_4373_100324)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0035 115.63C99.5407 115.63 103.219 111.944 103.219 107.397C103.219 102.85 99.5407 99.1641 95.0035 99.1641C90.4662 99.1641 86.7881 102.85 86.7881 107.397C86.7881 111.944 90.4662 115.63 95.0035 115.63Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6709 111.074C98.6709 109.044 97.0283 107.397 95.002 107.397C92.9757 107.397 91.333 109.044 91.333 111.074V129.512C91.333 131.543 92.9757 133.189 95.002 133.189C97.0283 133.189 98.6709 131.543 98.6709 129.512V111.074Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4373_100324",
    x: 40.343,
    y: 60.0072,
    width: 123.971,
    height: 130.971,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.3285,
    dy: 10.9928
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9928
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.572549 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4373_100324"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4373_100324",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4373_100324",
    x1: 208.294,
    y1: 24.3467,
    x2: 207.549,
    y2: 98.2076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAFCFF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EDF6FF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D8EDFF",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BCE0FF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4373_100324",
    x1: 37.0378,
    y1: 22.6199,
    x2: 36.2926,
    y2: 96.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAFCFF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EDF6FF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D8EDFF",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BCE0FF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4373_100324",
    x1: 119.814,
    y1: 51.9264,
    x2: 120.447,
    y2: 356.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F9FCFF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E0F0FF",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CBE7FF",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#BBDFFF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#AFDAFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A8D7FF",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4373_100324",
    x1: 33.9859,
    y1: 100.544,
    x2: 34.465,
    y2: 156.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAFCFF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EDF6FF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D8EDFF",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BCE0FF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4373_100324",
    x1: 167.062,
    y1: 200.479,
    x2: 94.3872,
    y2: 28.0023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B5DCFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0E9FF",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E5F3FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F4FAFF",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCFDFF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.93
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4373_100324",
    x1: 116.814,
    y1: 100.698,
    x2: 173.374,
    y2: 100.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4373_100324",
    x1: 131.568,
    y1: 57.9248,
    x2: 133.011,
    y2: 79.0417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.93
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4373_100324",
    x1: 96.7889,
    y1: 205.674,
    x2: 101.212,
    y2: 64.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0092E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4373_100324",
    x1: 39.9329,
    y1: 47.3344,
    x2: 115.585,
    y2: 154.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0092E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4373_100324",
    x1: 63.1521,
    y1: 131.571,
    x2: 126.849,
    y2: 131.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#090808",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#171515",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#201C1D",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4373_100324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 111,
    fill: "white",
    transform: "translate(0 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBotIntroduction);
export default __webpack_public_path__ + "static/media/image_bot_introduction.6065039c23d23ead2404242e22aa54a7.svg";
export { ForwardRef as ReactComponent };